module.exports = __webpack_public_path__ + "static/media/laymen-social-share.ea20b680.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/viewer-consent/laymen-social-share.png
// module id = 256
// module chunks = 0